import {
    CHANGED_LANGUAGE_ERROR,
    CHANGED_LANGUAGE_SUCCESS,
    ReceiveChangedLanguageSuccessAction,
    ReceiveChangedLanguageWithErrorAction,
} from '../types';
import { changeDashboardLanguage } from '../../../../services/SettingsServiceAPI';
import { DashboardLang } from '../../../../constants/DashboardLang';

export function changeLanguage(languageCode: DashboardLang): (dispatch: any) => void {
    return async (dispatch: any) => {
        try {
            await changeDashboardLanguage(languageCode);
            dispatch(changeLanguageSuccess(true));
        } catch (error) {
            dispatch(changeLanguageWithError(new Error(error)));
        }
    };
}
const changeLanguageSuccess = (changedLanguageSuccess: boolean): ReceiveChangedLanguageSuccessAction => {
    return {
        type: CHANGED_LANGUAGE_SUCCESS,
        payload: { changedLanguageSuccess },
    };
};
const changeLanguageWithError = (error: Error): ReceiveChangedLanguageWithErrorAction => {
    return {
        type: CHANGED_LANGUAGE_ERROR,
        error,
    };
};
